import { Box, Stack } from '@mui/material';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { PageTitle } from '@/ui/components/PageTitle';

export function PageTitles() {
  return (
    <Stack>
      <Box sx={{ backgroundColor: '#323323' }}>
        <PageTitle
          title="Page title"
          subtitle="Page subtitle leleleelel"
          backButtonText="back text"
          onClickBack={() => {}}
        />
      </Box>
      <Box sx={{ backgroundColor: '#331323' }}>
        <PageTitle
          title="Page title with button on the right"
          subtitle="Page subtitle leleleelel"
          backButtonText="back text"
          onClickBack={() => {}}
          rightComponent={
            <FSPrimaryButton>Button on the right</FSPrimaryButton>
          }
        />
      </Box>
    </Stack>
  );
}
